import { Component, OnInit, Output, Input, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ProjetcsService } from '../../../projects/projetcs.service';
import { GlobalService } from '../../services/global.service';
import { FilterService } from '../../services/filter.service';

@Component({
    selector: 'app-delet-requirements-call',
    templateUrl: './delet-requirements-call.component.html',
    styleUrls: ['./delet-requirements-call.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeletRequirementsCallComponent implements OnInit {
	@Input() call: any;
	@Output() closeView = new EventEmitter<string>();
	@Output() notify = new EventEmitter<string>();

	close() {
		this.closeView.emit();
	}
	submitForm() {
		this._pS.deletRequirmentCall(this.call.id)
			.subscribe(
				data => {
					var vdata: any = data;
					this.notify.emit();

				}
			)
	}

	constructor(private _pS: ProjetcsService, public _gS: GlobalService, private _fS: FilterService, private datePipe: DatePipe) { }

	ngOnInit() {
	}

}